import {isArabic} from "../common/Translator";

export default function NavBarTemplate(data) {
    //language=HTML
    return `
        <header>
            <nav class="navbar navbar-expand-lg navbar-light bg-primary px-md-1" id="nama-erp-header">
                <div class="container-fluid px-md-1">
                    <div class="row w-100 justify-content-between align-items-center m-auto">

                        <div class="col-lg-3 px-md-0">
                            <div class=" d-flex justify-content-lg-start justify-content-between align-items-center">
                                <a title="${translateId("showMenu")}" href="#mmenu" class="px-md-2"><i class="fa-solid fa-bars fa-2x text-white"></i></a>
                                <a title="${translateId("about")}" class="navbar-brand ${window.branding}-logo" id="applicationInfo" href="#">
                                    <img class="w-100" src=${data.smLogoImg}>
                                </a>
                                <!-- style="max-height: 50px" consider-->
                                <div class="line-h d-none d-lg-block"></div>
                                <form class="search form-inline my-2 my-lg-0 d-none d-lg-block">
                                    <input class="form-control mr-sm-2" id="headerSearchIn" placeholder='${data.translateId("searchByNameOrCode")}'
                                           aria-label="Search">
                                    <button type="submit"><i href="#" class="fa-solid fa-magnifying-glass"></i></button>
                                    <input class="form-control mr-sm-2" id="headerSearch" placeholder='${data.translateId("searchByNameOrCode")}'
                                           aria-label="Search">
                                </form>
                                <button class="navbar-toggler border-0 p-0 fa-2x" type="button" data-toggle="collapse"
                                        data-target=".navbarShowHideContent"
                                        aria-controls="navbarShowHideContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <i class="fa-solid fa-ellipsis-vertical text-white"></i>
                                </button>
                            </div>
                        </div>

                        <div class="col-lg-3 px-md-0">
                            <div class="collapse navbar-collapse navbarShowHideContent">
                                <div class=" py-0 w-100 d-flex flex-column-reverse">
                                    <form class="search form-inline d-flex d-lg-none mx-auto my-2 w-75">
                                        <button type="submit"><i class="fa-solid fa-magnifying-glass"></i></button>
                                        <input class="form-control w-100" id="headerSearchInMobile" placeholder='${data.translateId("searchInHelp")}'
                                               aria-label="Search">
                                        <input class="form-control w-100" id="headerSearchMobile"
                                               placeholder='${data.translateId("searchByNameOrCode")}'
                                               aria-label="Search">
                                    </form>
                                    <ul class=" navbar-nav justify-content-center align-items-center flex-row p-0">
                                        <li>
                                            <a id="notifications" href="#">
                                                <i class="fa-solid fa-bell"></i>
                                                <span id="navbarNotificationsCounter" class="notification"></span>
                                            </a>
                                            <div id="notificationsPopup" class="k-popup-header n-text-right popUpWindow">
                                                <div class="d-flex align-items-center justify-content-between bg-light px-2 py-1">
                                                    <div>
                                                        <span class=" h5 font-weight-bold">${data.translateId("Notification")}</span>
                                                    </div>

                                                    <div class="btn-popover-not btn-group">
                                                        <button class="btn text-secondary  d-flex">
                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>

                                                    </div>


                                                </div>
                                                <div id="notificationsList" class=" px-2 px-md-4">
                                                    <ol>
                                                    </ol>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <a id="accept" href="#">
                                                <i class="fa-solid fa-thumbs-up"></i>
                                                <span id="navbarApprovalsCounter" class="notification"></span>
                                            </a>
                                            <div id="acceptPopup" class="k-popup-header n-text-right popUpWindow">
                                                <div class="d-flex align-items-center justify-content-between bg-light px-2 py-1">
                                                    <div>
                                                        <span class=" h5 font-weight-bold">${data.translateId("approvals")}</span>
                                                    </div>

                                                    <div class="btn-popover-accept btn-group drop${isArabic() ? "right" : "left"}">
                                                        <button class="btn text-secondary dropdown-toggle dropdown-toggle-split d-flex"
                                                                aria-haspopup="true" aria-expanded="false">
                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                        </button>

                                                    </div>
                                                </div>
                                                <div id="approvalList" class=" px-2 px-md-3">
                                                    <ol class=" list-unstyled mb-0">
                                                    </ol>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <a id="undoQrCode" href="#">
                                                <i class="fa-solid fa-qrcode"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a id="backToOldGui" target="_blank">
                                                <i class="fa-solid fa-face-smile"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a id="goToHome" target="_blank">
                                                <i class="fa-solid fa-home"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                        <div class="col-lg-3 px-md-0 text-center text-white">
                            <div class="collapse navbar-collapse justify-content-center navbarShowHideContent">
                                <h5 id="navbarSupportedContent" class="m-0"></h5>
                            </div>
                        </div>

                        <div class="col-lg-3 px-md-0">
                            <div class="collapse navbar-collapse navbarShowHideContent">
                                <div class=" d-flex justify-content-lg-end justify-content-center align-items-center w-100">
                                    <ul id="menu">
                                        <li>
                                            <span class="currentUserName"></span>
                                            <i id="userImg1" class="fa-solid fa-user"></i>
                                            <ul>
                                                <li>
                                                    <div id="template" class=" px-2 pt-4 pb-3">
                                                        <div class="text-center mb-4">
                                                            <i id="userImg2" class="fa-solid fa-user mb-1"></i>
                                                            <h5 class="currentUserName"></h5>
                                                        </div>
                                                        <div class="optins row m-0">
                                                            <div class="col-md-7 px-1 mb-1">
                                                                <button id="changePassword" class=" k-button btn-block">
                                                                    ${data.translateId("changePassword")}
                                                                </button>
                                                            </div>
                                                            <div class="col-md-5 px-1 mb-1">
                                                                <button id="LogoutBtn" class=" k-button btn-block">${data.translateId("logout")}
                                                                </button>
                                                            </div>
                                                            <div class="col-12 px-1 mb-1">
                                                                <div class="chang-color n-text-right">
                                                                    <input class=" w-100" id="colors"/>
                                                                </div>
                                                            </div>
                                                            <div class="col-4 px-1 mb-1">
                                                                <div class="change-font n-text-right">
                                                                    <input class=" w-100" id="fontSize"/>
                                                                </div>
                                                            </div>
                                                            <div class="col-8 px-1 mb-1">
                                                                <div class="change-font n-text-right">
                                                                    <input class=" w-100" id="fontFamily"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                    <div class="line-h"></div>
                                    <div class="theme-lang d-flex align-items-center">
                                        <a id="currentLegalEntity" href="#" class=" text-white px-2"></a>
                                        <a id="lang_btn" href="#" class="lang text-white mr-2">
                                            <div>
                                                ${isArabic() ? drawEnglishIcon() : drawArabicIcon()}
                                            </div>
                                        </a>
                                        <div class="theme d-flex border border-white mr-2">
                                            <div class=" bg-warning"></div>
                                            <div class=" bg-primary"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </nav>
        </header>`;
}

export function bodyTemplateApproval() {
    //language=HTML
    return `
        <script id="body-template-accept" type="text/x-kendo-template">
            <div class="template-wrapper">
                <button id="allApprovals" class=" k-button dropdown-item">
                    ${translateId("viewAllApprovals")}
                </button>
            </div>
        </script>`;
}

export function bodyTemplateNotification() {
    //language=HTML
    return `
        <script id="body-template-not" type="text/x-kendo-template">
            <div class="template-wrapper">
                <button id="allNotifications" class=" k-button dropdown-item mb-2" type="button">
                    ${translateId("viewAllNotifications")}
                </button>
                <button id="markAsRead" class=" k-button dropdown-item bg-white" type="button">
                    <!--                                                        <i class="fa-solid fa-check ml-2"></i>-->
                    <span>${translateId("markAsRead")}</span>
                </button>
            </div>
        </script>`;
}
export function drawEnglishIcon() {
    //language=HTML
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 799.48 741.46" style="width: 2.5rem;">
            <title>${translateId("changeLocale")}</title>
            <g id="4c7517ec-fb18-439e-aea1-a62a548b4483" data-name="Layer 2">
                <g id="1183ec84-7266-46ab-8eab-8190ae0f10f7" data-name="Layer 1">
                    <path d="M799.4,371.48a86.43,86.43,0,0,0-1.6-16.9c-8.3-41.3-42.6-69.4-84.7-69.4q-124.8-.15-249.5,0h-6.9v-7q0-95.55,0-191c-.1-49.5-37.5-87-87-87.09Q228.4-.08,87.2.08C37.4.17,0,37.58,0,87.48Q0,228.18.1,369a100.72,100.72,0,0,0,2,19.79c9,40.31,43.3,67.6,84.8,67.6q124.2.16,248.5,0h7.2c0,2.71,0,4.71-.1,6.51,0,64.2-.2,128.3,0,192.5.1,48.1,38.1,86,86.2,86q142.2.15,284.5,0c48.4,0,86.2-37.9,86.2-86.4Q799.55,513.23,799.4,371.48Zm-404.1-79a84.69,84.69,0,0,0-52.7,78.1c-.1,9.4,0,18.9,0,28.79H87.8c-18.6,0-30.4-11.6-30.4-30.1V87.38c0-18.5,11.5-30.1,29.8-30.1H370.1c18,0,29.6,11.7,29.6,29.8q0,99.13.1,198.4C399.8,289.18,398.9,291,395.3,292.48ZM685.43,670.42H629.82L529,473.2q-8.86-17.3-12.28-26H516q1.35,16.63,1.36,50.79V670.42h-52V356.54h59.36L621.8,547.62q6.66,12.91,12.28,25.61h.68q-1.36-10.93-1.36-43.12V356.54h52Z"
                          style="fill:#fff"/>
                    <path d="M187.39,307.74v-53h123v-53h-123v-53h104l-40.16-53H134.37V360.77l186.57.25V308Z"
                          style="fill:#fff"/>
                </g>
            </g>
        </svg>`;
}
export function drawArabicIcon() {
    //language=HTML
    return `
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 837.7 774.7" style="width: 2.5rem;">
            <title>${translateId("changeLocale")}</title>
            <g>
                <path fill="white" d="M358.7,473.9c-2.9,0-5,0-7.2,0c-82.8,0-165.7,0.1-248.5,0c-41.5,0-75.8-27.3-84.8-67.6c-1.4-6.4-1.9-13.2-2-19.8
                                                            c-0.1-93.8-0.1-187.7-0.1-281.5c0-49.9,37.4-87.3,87.2-87.4c94.2-0.1,188.3-0.1,282.5,0c49.5,0.1,86.9,37.6,87,87.1
                                                            c0.1,63.7,0,127.3,0,191c0,2.1,0,4.3,0,7c2.7,0,4.8,0,6.9,0c83.2,0,166.3-0.1,249.5,0c42.1,0,76.4,28.1,84.7,69.4
                                                            c1.1,5.5,1.6,11.2,1.6,16.9c0.1,94.5,0.1,189,0,283.5c0,48.5-37.8,86.4-86.2,86.4c-94.8,0.1-189.7,0.1-284.5,0
                                                            c-48.1,0-86.1-37.9-86.2-86c-0.2-64.2,0-128.3,0-192.5C358.7,478.6,358.7,476.6,358.7,473.9z M358.7,416.9c0-9.9-0.1-19.4,0-28.8
                                                            c0.3-34.4,20.8-65.1,52.7-78.1c3.6-1.5,4.5-3.3,4.5-7c-0.1-66.1-0.1-132.3-0.1-198.4c0-18.1-11.6-29.8-29.6-29.8
                                                            c-94.3,0-188.6,0-282.9,0c-18.3,0-29.8,11.6-29.8,30.1c0,94,0,187.9,0,281.9c0,18.5,11.8,30.1,30.4,30.1c83.1,0,166.3,0,249.4,0
                                                            C354.8,416.9,356.5,416.9,358.7,416.9z M744.7,649.6c-2.3,0.1-3.2,0.1-4.1,0.2c-31.5,3.5-63.1,4.7-94.8,1.3
                                                            c-22.5-2.4-44.5-6.7-64.7-17.4c-21.1-11.1-36.4-26.8-39.2-51.9c-2.7-24.9,9.1-47.4,30.5-56.7c19.4-8.4,39.9-11,60.6-6.4
                                                            c10.9,2.4,21.2,7.2,32.3,11.1c7.8-24.4,15.9-49.9,24.3-76.1c-2.8,0.8-4.5,1.3-6.3,1.8c-24.1,6.8-48.5,12.3-73.7,11.4
                                                            c-13-0.5-25.4-3.7-35.8-12.2c-19.8-16.3-15.9-43.7,7.5-53.6c3.2-1.4,6.6-2.4,10-3.2c14.9-3.2,29.9-2.3,44.8-0.4
                                                            c9.7,1.2,19.3,3.2,29.3,4.9c0-8.8-0.2-17.5,0.1-26.1c0.2-4.2-1.2-6.1-5.3-7.4c-28.1-8.9-56.7-11.5-85.9-6.8
                                                            c-25.3,4-46.9,14.8-62.2,36c-24,33.3-19.6,83.7,14,109.2c0.6,0.4,1,1.1,1.5,1.6c-0.5,0.5-0.7,0.8-1,1c-1.2,0.7-2.3,1.3-3.5,1.9
                                                            c-21.3,12.2-39.6,27.7-52.2,49.1c-19.8,33.6-16.1,72.1,10,99.7c16.1,17,36.7,26.8,58.9,33.3c34.6,10.1,69.7,10.3,104.9,4.3
                                                            c33.4-5.7,64.1-17.7,90.3-39.8C738.2,656,741,653.2,744.7,649.6z"/>
                <path fill="white" d="M358.5,359.6c-19.1,0-37.7,0-56.7,0c0-18.8,0-37.4,0-56.4c-38.2,0-75.9,0-114,0c0,18.6,0,37.2,0,56.2
                                                            c-19.2,0-37.9,0-57.1,0c-0.1-1.7-0.2-3.5-0.2-5.3c0-64,0-128,0-192c0-18.9,11.7-30.5,30.6-30.5c27.2,0,54.3,0.1,81.5-0.1
                                                            c8.8-0.1,16.2,2.8,22.8,8.5c27.3,23.5,54.6,46.9,82,70.2c7.3,6.2,11.4,13.7,11.4,23.4c0,40.7,0,81.3,0,122
                                                            C358.7,356.9,358.6,358,358.5,359.6z M299.8,245.5c-1-1.1-1.3-1.7-1.8-2.1c-20.7-17.6-41.3-35.3-62.1-52.7
                                                            c-1.5-1.2-3.9-1.8-5.9-1.8c-10.5-0.2-21-0.1-31.5-0.1c-3.6,0-7.2,0-10.8,0c0,19.3,0,37.9,0,56.7C225,245.5,261.9,245.5,299.8,245.5
                                                            z"/>
            </g>
        </svg>`;
}